module.exports = __webpack_public_path__ + "img/3.eb722857.jpg";